import { CommentApi } from 'api/CommentApi';
import { apiClient } from 'container/apiClient';
import { questionMapper } from 'container/questionMapper';

export const commentApi = new CommentApi(apiClient, questionMapper);
